
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment optimiser vos images pour un meilleur SEO ?",
    description:
      "Améliorez votre référencement avec des images optimisées : formats, compression, balises ALT et outils pratiques. ALEO vous guide pour booster votre visibilité !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
